//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLottie from '@/components/UI/el-lottie'
import eventBus from '@/utils/eventBus'
import { mapState } from 'vuex'
import footerMixin from '@/mixins/footer.mixin'
import ElLink from '@/components/UI/el-link'
import AlgOfferLink from '@/components/common/links/AlgOfferLink'
import AlgMotkaLink from '@/components/common/links/AlgMotkaLink'
import AlgCopyrightText from '@/components/common/AlgCopyrightText'

export default {
  name: 'Footer',
  components: {
    AlgCopyrightText,
    AlgMotkaLink,
    AlgOfferLink,
    ElLottie,
    ElLink,
  },
  mixins: [footerMixin],
  data() {
    return {
      footerAnimation: {
        container: '.n-footer__big-pic',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/footer/footer.json`,
      },
    }
  },
  computed: {
    ...mapState(['i18n']),
    contactsText() {
      let contactText =
        this.$getTextMainSetting('footerContactsText').toString()

      contactText = contactText.replace(
        '#EMAIL#',
        '<a href="mailto:' +
          this.$getTextMainSetting('branchEmail') +
          '"><bdi>' +
          this.$getTextMainSetting('branchEmail') +
          '</bdi></a>'
      )

      contactText = contactText.replace(
        '#PHONE#',
        '<a class="tel" href="tel:+' +
          this.$getTextMainSetting('branchPhoneCanonical') +
          '"><bdi>' +
          this.$getTextMainSetting('branchPhone') +
          '</bdi></a>'
      )

      return contactText
    },
    isShowRussianBlocks() {
      return this.$getTextMainSetting('isRussianFranchise')
    },
  },
  methods: {
    isOfferLink() {
      return (
        !!this.$getTextMainSetting('offerLink') ||
        !!this.$getTextSetting('campOfferLink')
      )
    },
    getLogo() {
      if (this.$i18n.locale === 'ru') {
        return require(`~/assets/img/partner/main/header/logo-ru.svg`)
      }
      return require(`~/assets/img/partner/main/header/logo-en.png`)
    },
    handleClick(e) {
      if (e.target.matches('.n-footer__desc .tel')) {
        this.onPhoneNumberClick()
      }
    },
    onPhoneNumberClick() {
      eventBus.$emit('click-phone-number')
    },
  },
}
